<template>
  <b-modal v-model="modal" :title="title" size="lg" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="saveCampaign()" autocomplete="off">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">Nome da campanha</label>
                <input
                  id="name"
                  v-model="campaign.name"
                  name="name"
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.campaign.name.$error
                  }"
                />
                <div
                  v-if="submitted && !$v.campaign.name.required"
                  class="invalid-feedback"
                >
                  O campo nome é obrigatório.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="type_contact">Destinatários</label>
                <select
                  id="type_contact"
                  v-model="campaign.type_contact"
                  name="type_contact"
                  type="text"
                  class="custom-select"
                  :class="{
                    'is-invalid': submitted && $v.campaign.type_contact.$error
                  }"
                >
                  <option></option>
                  <option value="guests">Convidados</option>
                  <option value="registered">Inscritos</option>
                </select>
                <div
                  v-if="submitted && !$v.campaign.type_contact.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório.
                </div>
              </div>
            </div>
          </div>
          <!-- Filtros combinados (nova UI: chips compactos + adicionar) -->
          <campaign-filter-builder
            v-model="campaign.rules"
            :catalog="filterCatalog"
            :loading="catalogLoading"
          />

          <!-- Só faz sentido em evento "Com acompanhante" (registration_type = 2) -->
          <div class="row" v-if="hasCompanions">
            <div class="col-sm-12">
              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input
                    id="include_companions"
                    v-model="campaign.include_companions"
                    type="checkbox"
                    class="custom-control-input"
                  />
                  <label class="custom-control-label" for="include_companions">
                    Enviar também para os acompanhantes
                  </label>
                </div>
                <small class="form-text text-muted">
                  Os acompanhantes dos participantes selecionados também receberão este e-mail,
                  mesmo que não atendam aos filtros acima. Acompanhantes sem e-mail cadastrado
                  são ignorados.
                </small>
              </div>
            </div>
          </div>

          <!-- Preview de contagem -->
          <div class="count-box" v-if="campaign.type_contact">
            <i class="bx bx-group"></i>
            <span v-if="countLoading"><i class="bx bx-loader-alt bx-spin"></i> Calculando...</span>
            <span v-else-if="participantCount > 0"><strong>{{ participantCount }}</strong> {{ participantCount === 1 ? 'participante será afetado' : 'participantes serão afetados' }}</span>
            <span v-else class="text-warning">Nenhum participante encontrado com os filtros selecionados</span>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="template_id">Template</label>
                <select
                  class="custom-select"
                  name="template_id"
                  v-model="campaign.template_id"
                  @change="setTemplate(campaign.template_id)"
                  :class="{
                    'is-invalid': submitted && $v.campaign.template_id.$error
                  }"
                >
                  <option></option>
                  <option v-for="(t,i) in emailtemplates" :key=i :value="t.id">{{ t.subject }}</option>
                </select>
                <div
                  v-if="submitted && !$v.campaign.template_id.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório.
                </div>
                <button type="button" class="btn btn-outline-dark btn-sm mt-2" v-if="campaign.template_id" @click="showExampleTemplate">
                  <i class="bx bx-show link" ></i> Ver exemplo do template
                </button>
              </div>
            </div>
          </div>
          <div class="row" v-if="templateHasUrlAcao">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="follow_up_rule_id">Regra de Ação de Retorno (opcional)</label>
                <select
                  class="custom-select"
                  name="follow_up_rule_id"
                  v-model="campaign.follow_up_rule_id"
                >
                  <option value="">Nenhuma (campanha sem ação de retorno)</option>
                  <option v-for="rule in followUpRulesList" :key="rule.id" :value="rule.id">{{ rule.name }}</option>
                </select>
                <small class="form-text text-muted" v-if="campaign.follow_up_rule_id">
                  Cada participante receberá um link personalizado de ação de retorno no email. Use a variável <code>{$urlacao}</code> no template.
                </small>
              </div>
            </div>
          </div>
          <div class="row" v-if="showHeader">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="header_banner">Header Imagem</label>
                <input
                  class="form-control"
                  ref="header_banner"
                  name="header_banner"
                  type="file"
                >
                <div
                  v-if="showHeader"
                  class="invalid-feedback"
                >
                  Template escolhido exige uma imagem no HEADER.
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 1rem">
            <div class="col-sm-3">
              <div style="display:flex; align-items: start; gap: 5px;margin-top: 0.55rem">
                <span style="font-weight: 500;margin-top:2px">Agendar disparo</span>
                <b-form-checkbox v-model="campaign.has_scheduled_at" switch size="lg"></b-form-checkbox>
              </div>
            </div>
            <div class="col-sm-4" v-if="campaign.has_scheduled_at">
              <!-- <label for="scheduled_at">Data do Agendamento</label> -->
              <date-picker
                v-model="campaign.scheduled_at"
                type="datetime"
                :first-day-of-week="1"
                lang="pt-br"
                format="DD/MM/YYYY HH:mm"
                name="scheduled_at"
              >
              </date-picker>
            </div>
          </div>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="saveCampaign()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import http from '@/http'
import { list as listFollowUpRules } from '@/pages/settings/follow-up-rules/services'
import CampaignFilterBuilder from '@/components/modals/filters/CampaignFilterBuilder.vue'

export default {
  components: {
    Loading,
    DatePicker,
    CampaignFilterBuilder
  },
  props: {
    idcampaign: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      title: 'Nova Campanha',
      showHeader: false,
      loading: true,
      fullPage: true,
      submitted: false,
      campaign: {
        rules: [],
        follow_up_rule_id: '',
        include_companions: false
      },
      filterCatalog: [],
      catalogLoading: false,
      followUpRulesList: [],
      modal: false,
      participantCount: 0,
      countLoading: false,
      countTimer: null
    }
  },
  validations: {
    campaign: {
      name: { required },
      type_contact: { required },
      template_id: { required }
    }
  },
  methods: {
    ...mapActions('settings', { GetStatus: 'GetStatusSelect', GetRefStatus: 'GetRefStatusList' }),
    ...mapActions('settingRSVP', { GetRSVP: 'GetRSVP' }),
    ...mapActions('ecampaign', {
      getCampaign: 'show',
      postData: 'save'
    }),
    ...mapActions('emailTemplate', {
      getTemplatesAll: 'getAll'
    }),
    ...mapActions('tag', {
      getAll: 'getAll'
    }),
    ...mapActions('group', {
      getAllGroups: 'getAll'
    }),
    setTemplate (templateId) {
      if (templateId) {
        const template = this.emailtemplates.find(t => t.id === this.campaign.template_id)
        if (template && !template.content?.toLowerCase().includes('$urlacao')) {
          this.campaign.follow_up_rule_id = ''
        }
      } else {
        this.campaign.follow_up_rule_id = ''
      }
    },
    showExampleTemplate () {
      const template = this.emailtemplates.filter((t) => t.id === this.campaign.template_id)[0]
      if (template) {
        this.$emit('exampleTemplate', template.content)
      }
    },
    async getFollowUpRules () {
      try {
        const res = await listFollowUpRules({ limit: 100, page: 1 })
        this.followUpRulesList = res.data.data || []
      } catch (e) {
        console.log(e)
      }
    },
    loadItem (id) {
      if (id) {
        this.title = 'Editar Campanha'
        this.getCampaign(id).then((data) => {
          this.campaign = this.data
          // Hidrata rules a partir de filters JSON (novo) ou filters_with_fallback (legado)
          const fwf = (this.data && (this.data.filters || this.data.filters_with_fallback)) || null
          this.campaign.rules = (fwf && Array.isArray(fwf.rules)) ? fwf.rules : []
        }).then(() => {
          this.loading = false
        })
      }
    },
    fetchFilterCatalog () {
      if (this.filterCatalog.length > 0) return
      this.catalogLoading = true
      http.get('/admin/campaigns/filters/available').then(res => {
        this.filterCatalog = (res.data && res.data.data) || []
      }).catch(() => {
        this.filterCatalog = []
      }).finally(() => {
        this.catalogLoading = false
      })
    },
    getTags (filter) {
      let params = {
        search: this.search || null,
        limit: 100,
        page: 1
      }
      this.params = params
      this.getAll(this.params).then((res) => {
        // this.participants = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    getTemplates () {
      let params = {
        search: this.search || null,
        status: 1,
        limit: 100,
        page: 1
      }
      this.params = params
      this.getTemplatesAll(this.params).then((res) => {
      }).catch(error => {
        console.log(error)
      })
    },
    getGroups () {
      let params = {
        search: this.search || null,
        status: 1,
        limit: 100,
        page: 1
      }
      this.params = params
      this.getAllGroups(this.params).then((res) => {
      }).catch(error => {
        console.log(error)
      })
    },
    open (id = null) {
      this.getTags()
      this.getTemplates()
      this.getGroups()
      this.GetStatus()
      this.GetRefStatus()
      this.GetRSVP()
      this.getFollowUpRules()
      this.fetchFilterCatalog()
      this.modal = true
      this.loading = true
      if (id) {
        this.loadItem(id)
        return
      }
      if (!Array.isArray(this.campaign.rules)) {
        this.$set(this.campaign, 'rules', [])
      }
      this.loading = false
    },
    async saveCampaign () {
      this.submitted = true
      this.$v.campaign.$touch()
      if (this.$v.campaign.$invalid) {
        window.scroll(0, 0)
        return
      }
      this.loading = true
      if (this.campaign.has_scheduled_at) {
        this.campaign.scheduled_at = this.$moment(this.campaign.scheduled_at).format('YYYY-MM-DD HH:mm:ss')
      }

      const formData = new FormData()
      formData.append('id', this.campaign.id || '')
      formData.append('name', this.campaign.name)
      formData.append('type_contact', this.campaign.type_contact)
      // type_filter e select_filter construídos automaticamente no backend a partir de rules
      formData.append('template_id', this.campaign.template_id)
      formData.append('rules', JSON.stringify(this.campaign.rules || []))
      formData.append('follow_up_rule_id', this.campaign.follow_up_rule_id || '')
      // FormData serializa booleano como string: manda 1/0 para o boolean() do Laravel.
      formData.append('include_companions', (this.hasCompanions && this.campaign.include_companions) ? 1 : 0)
      formData.append('has_scheduled_at', this.campaign.has_scheduled_at)
      formData.append('scheduled_at', this.campaign.scheduled_at)

      await this.postData(formData).then(res => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.close()
        this.$emit('created')
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.campaign = {
        rules: [],
        follow_up_rule_id: '',
        include_companions: false
      }
      this.participantCount = 0
      this.countLoading = false
      this.$v.$reset()
    },
    fetchCount () {
      if (this.countTimer) clearTimeout(this.countTimer)
      if (!this.campaign.type_contact) {
        this.participantCount = 0
        return
      }
      this.countTimer = setTimeout(() => {
        this.countLoading = true
        http.post('/admin/email/campaigns/count-participants', {
          type_contact: this.campaign.type_contact,
          rules: JSON.stringify(this.campaign.rules || []),
          include_companions: (this.hasCompanions && this.campaign.include_companions) ? 1 : 0
        }).then(res => {
          this.participantCount = res.data.count || 0
          this.countLoading = false
        }).catch(() => {
          this.participantCount = 0
          this.countLoading = false
        })
      }, 400)
    }
  },
  computed: {
    ...mapState('settings', ['statusSelect', 'refstatusList']),
    ...mapState('settingRSVP', { settingRSVP: 'settingRSVP' }),
    ...mapState('ecampaign', { data: 'campaign' }),
    ...mapState('emailTemplate', ['emailtemplates']),
    ...mapState('tag', ['tags']),
    ...mapState('group', ['groups']),
    templateHasUrlAcao () {
      if (!this.campaign.template_id) return false
      const tpl = this.emailtemplates.find(t => t.id === this.campaign.template_id)
      return tpl && tpl.content && tpl.content.toLowerCase().includes('$urlacao')
    },
    // Evento "Com acompanhante" — mesmo teste usado em participants/Form.vue e no form-builder.
    hasCompanions () {
      return this.settingRSVP && parseInt(this.settingRSVP.registration_type) === 2
    }
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    },
    'campaign.type_contact' () { this.fetchCount() },
    'campaign.include_companions' () { this.fetchCount() },
    'campaign.rules': {
      deep: true,
      handler () { this.fetchCount() }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
.count-box {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #f4f5f7;
  border-radius: 6px;
  font-size: 14px;
  color: #495057;
  margin-top: 4px;
  margin-bottom: 16px;
}
.count-box i.bx-group {
  font-size: 18px;
  color: #556ee6;
}
</style>
